import {
  CANCEL_RECEIPT_DATA,
  GET_DEBT_BY_POL_APP_DATA,
  GET_DEBT_BY_POL_FOR_RENEWAL_PREM_DATA,
  GET_LIST_LOV_DATA,
  GET_RECEIPT_DETAIL_DATA,
  GET_RECEIPT_LIST_DATA,
  GET_VALID_AGENT_DATA,
  SET_LIST_LOV_DATA,
  SET_RECEIPT_DATA,
  SET_RECEIPT_DETAIL_DATA,
  SET_RECEIPT_LIST_DATA,
} from '@stores/fee/constants.js';

const getListLoveDataAction = (payload) => ({
  type: GET_LIST_LOV_DATA,
  payload,
});

const setListLoveDataAction = (payload) => ({
  type: SET_LIST_LOV_DATA,
  payload,
});

const getReceiptListDataAction = (payload) => ({
  type: GET_RECEIPT_LIST_DATA,
  payload,
});

const setReceiptListDataAction = (payload) => ({
  type: SET_RECEIPT_LIST_DATA,
  payload,
});

const getReceiptDetailDataAction = (payload) => ({
  type: GET_RECEIPT_DETAIL_DATA,
  payload,
});

const setReceiptDetailDataAction = (payload) => ({
  type: SET_RECEIPT_DETAIL_DATA,
  payload,
});

const getValidAgentAction = (payload, callback) => ({
  type: GET_VALID_AGENT_DATA,
  payload,
  callback,
});

const getDebtByPolOrAppAction = (payload, callback) => ({
  type: GET_DEBT_BY_POL_APP_DATA,
  payload,
  callback,
});

const getDebtByPolForRenewalPremAction = (payload, callback) => ({
  type: GET_DEBT_BY_POL_FOR_RENEWAL_PREM_DATA,
  payload,
  callback,
});

const setReceiptDataAction = (payload, callback) => ({
  type: SET_RECEIPT_DATA,
  payload,
  callback,
});

const cancelReceiptDataAction = (payload, callback) => ({
  type: CANCEL_RECEIPT_DATA,
  payload,
  callback,
});

export {
  getListLoveDataAction,
  setListLoveDataAction,
  getReceiptListDataAction,
  setReceiptListDataAction,
  getReceiptDetailDataAction,
  setReceiptDetailDataAction,
  getValidAgentAction,
  getDebtByPolOrAppAction,
  setReceiptDataAction,
  getDebtByPolForRenewalPremAction,
  cancelReceiptDataAction,
};
